/**
 * _type-b ヘッダーのスクロール制御
 *
 * .js-header-trigger 要素がビューポートから消えたら
 * .s-header から _type-b を外し、通常の固定ヘッダーに切り替える。
 * ハンバーガーメニューが開いている間は _type-b を外したまま維持する。
 */
export const headerTypeB = () => {
  const header = document.querySelector(".s-header._type-b");
  if (!header) return;

  const trigger = document.querySelector(".js-header-trigger");
  if (!trigger) return;

  const hamburger = document.querySelector(".js-hamburger");

  let isTriggerVisible = true;
  let isMenuOpen = false;

  const updateHeader = () => {
    header.classList.toggle("_type-b", isTriggerVisible && !isMenuOpen);
  };

  const observer = new IntersectionObserver(
    ([entry]) => {
      isTriggerVisible = entry.isIntersecting;
      updateHeader();
    },
    { threshold: 0 }
  );

  observer.observe(trigger);

  if (hamburger) {
    const attrObserver = new MutationObserver(() => {
      isMenuOpen = hamburger.getAttribute("aria-expanded") === "true";
      updateHeader();
    });

    attrObserver.observe(hamburger, {
      attributes: true,
      attributeFilter: ["aria-expanded"],
    });
  }
};
